import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Fez extends PositionedGoodyHOC {
	// 3
	render() {
		const style = {
			st25: {
				fill: '#FC5959',
			},
			st26: {
				fill: '#EAB049',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="25.414978" cy="58.7372284" />
				<path style={style.st25} d="M47.0372314,3.387193c0-1.8640138-9.1035156-3.375-20.333252-3.375
					s-20.3334961,1.5109863-20.3334961,3.375l-6.2038574,49h0.0002441c17.0708008,5.8344727,35.5957031,5.8344727,52.6665039,0
					L47.0372314,3.387193z" />
				<path style={style.st26} d="M47.5062256,36.6108246l-3.0505371-9.3195782l-0.1833496-0.5595703
					c0.7995605-0.7614746,1.3164062-1.8212891,1.3586426-3.0117188c0.0678711-1.9206543-1.1208496-3.5783691-2.8215332-4.2277832
					l-1.026123-14.4086924c-0.0507812-0.7099609-0.5927734-1.2866209-1.2988281-1.3803709L26.9014893,1.9003764
					c-0.8242188-0.1166992-1.5751953,0.4682618-1.6845703,1.2895509c-0.1083984,0.8212888,0.46875,1.5751951,1.2900391,1.6840818
					L38.8780518,6.516099l0.9208984,12.9294443c-1.6450195,0.5827637-2.8525391,2.1152344-2.9179688,3.9648438
					c-0.0568848,1.6047363,0.767334,3.0234375,2.0283203,3.8303223l-0.0771484,0.3881836l-1.8745117,9.4194317
					c-0.1589355,0.7980957,0.4753418,1.2880859,1.2189941,1.6184082c1.7736816,0.7878418,5.5725098,1.1508789,8.3830566-0.3039551
					C47.2589111,38.0007172,47.7513428,37.3591156,47.5062256,36.6108246z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Fez.js